<div class="table-responsive">
  <table id="listViewTable" class="table table-striped panel panel-default">
    <thead class="panel-heading">
    <tr>
      <th style="width: 10px;" *ngIf="inputType !== 'none'">
        <input id="allCheckbox" type="checkbox" (click)="selectAll()" [(ngModel)]="isAllSelected"
               *ngIf="inputType === 'checkbox'"/>
      </th>
      <th *ngFor="let key of filteredDisplayFields">
        {{ service.meta.fields[key].label }}
        <app-table-sort-order-v2 *ngIf="!disableSort.includes(key)" [field]="key"
                                 (orderingChange)="orderingChange($event)"></app-table-sort-order-v2>

      </th>
      <th *ngIf="items && items.length > 0 && rowIcons.length" [colSpan]="rowIcons.length"></th>
      <th *ngIf="items && items.length > 0 && rowButtons.length" [colSpan]="rowButtons.length"></th>
    </tr>
    </thead>
    <tbody>
    <tr *ngIf="loading">
      <td [colSpan]="displayFields.length"><i class="fa fa-spinner fa-pulse"></i></td>
    </tr>
    <ng-container *ngIf="!loading">
      <tr *ngFor="let item of items">
        <td *ngIf="inputType !== 'none'" [ngStyle]="getExtraStyling(item)">
          <input id="checkbox_{{ item.globalid }}" type="checkbox" [(ngModel)]="item.selected"
                 *ngIf="inputType === 'checkbox'">
          <input name="select" [(ngModel)]="match.match" type="radio" [value]="item.globalid"
                 *ngIf="inputType==='radio'">
        </td>
        <td *ngFor="let key of filteredDisplayFields; let i = index;" [ngStyle]="getExtraStyling(item)">
          <a *ngIf="i === 0 && showLink" [routerLink]="['/site', item.site_id]">
            <app-display-field [type]="service.meta.fields[key].type" [value]="item[key]"
                               [icons]="columnIcons[key]"
                               [choices]="service.meta.fields[key].choices"></app-display-field>
          </a>
          <app-display-field *ngIf="i !== 0 || !showLink" [type]="service.meta.fields[key].type"
                             [value]="item[key]" [getChoices]="service.meta.fields[key].get_choices"
                             [choices]="service.meta.fields[key].choices"
                             [icons]="columnIcons[key]"></app-display-field>
        </td>
        <td *ngFor="let icon of rowIcons" [ngStyle]="getExtraStyling(item)">
        <span *ngIf="hideExpressionEval(item, icon.hideExpression)" ngbTooltip="{{icon.title}}" placement="left"
              openDelay="500">
          <i class="fa fa-2x {{icon.class}}" style="margin-top: 5px; color: #33c033" aria-hidden="true"></i>
        </span>
        </td>
        <td *ngFor="let button of rowButtons" [ngStyle]="getExtraStyling(item)">
          <button *ngIf="hideExpressionEval(item, button.hideExpression)" class="btn btn-primary row-button"
                  (click)="button.func(item)"><span [innerHTML]="button.title"></span>
          </button>
        </td>
      </tr>
    </ng-container>
    <tr *ngIf="items && items.length === 0 && !loading">
      <td [colSpan]="displayFields.length">
        No items found.
      </td>
    </tr>
    </tbody>
  </table>

</div>
<div class="text-center" *ngIf="!loading && service.meta.pages > 1">
  <ngb-pagination [collectionSize]="service.meta.count" [(page)]="currentPage" [maxSize]="5"
                  pageSize="25" [boundaryLinks]="false" (pageChange)="switchPage(currentPage)" class="pagination">
  </ngb-pagination>
</div>
